import { render } from "./customAddressConfirm.vue?vue&type=template&id=916bf5be&scoped=true&lang=pug"
import script from "./customAddressConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./customAddressConfirm.vue?vue&type=script&setup=true&lang=js"

import "./customAddressConfirm.vue?vue&type=style&index=0&id=916bf5be&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916bf5be"]])

export default __exports__